import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CerSessionService } from '@cer/cer-session/cer-session.service';
import { CerPromptService } from '@ui/cer-ui-prompt.service';

@Component({
  selector: 'cer-app-layout-help-about',
  templateUrl: 'cer-app-layout-help-about.component.html',
  styleUrls: ['cer-app-layout-help-about.component.css']

})
export class CerAppLayoutHelpAboutComponent implements OnInit {

  public appName: string;
  public license: string;
  public copyright: string = 'Copyright 2020-2026 AIE ApS';
  public contact: string = 'mail@allaniversen.dk';
  public appVersion: string = '';
  public clientVersion: string = '';
  public hasSystemUpdate: boolean = false;
  protected hasLicence: boolean = false;

  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private session: CerSessionService,
    private ui: CerPromptService,
    private dialogRef: MatDialogRef<CerAppLayoutHelpAboutComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogParm: any) {

    this.appName = session.environment.title$.getValue();
    var licenseIssuedTo : string = session.environment.licenseIssuedTo$.getValue()
    this.hasLicence = licenseIssuedTo != null && licenseIssuedTo.length > 0;
    this.license = 'Brugsretten til denne app er licenseret uden begrænsninger til "'+licenseIssuedTo+'".',
    this.appVersion = session.environment.appVersion$.getValue();
    this.clientVersion = session.environment.clientVersion$.getValue();
    this.hasSystemUpdate = this.clientVersion != this.appVersion;
    this.clientUpd = this.session.environment.clientNeedsReload$.getValue();

    this.form = fb.group({

      license: [this.license],

      copyright: [this.copyright],

      appVersion: [this.appVersion],

      clientVersion: [this.clientVersion],

      contact: [this.contact]

    });
  }

  protected clientUpd: boolean = false;
  ngOnInit(): void {
    if (this.clientUpd) {
      this.askClientUpdate();
    }
  }

  private askClientUpdate() {
    const that = this;
    this.ui.confirm('Klient version skal opdateres. Opdater klient?',"Klient opdatering", { dialogArgs: { position: { Y: 'top'}}}).then(
      action => {
        if (action == 'ok') {
          that.clientUpdate();
        }
      }
    );
  }

  public clientUpdate() {
    var location: any = window.location;
    location.reload(true);
  }

  close() {
    this.dialogRef.close();
  }

}
